/**
 * ParticipantsSlide Component
 *
 * Ecranul separat pentru numarul de participanti la CLASS_EXERCISE.
 *
 * ⚠️ Din 2026-10-22 NU mai e calea normala: numarul se scrie pe pagina cu pozele
 * (`CampParticipanti` din `LessonPlayer`) si pleaca imediat dupa raspuns. Ecranul asta ramane
 * doar ca plasa — cand `PATCH`-ul de participanti pica sau `lessonAnswerId` lipseste, raspunsul
 * e deja salvat, deci aici se reincearca doar numarul, fara sa se retrimita pozele.
 *
 * Created: 2025-11-14 (CLASS_EXERCISE Participants Feature)
 */

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { CampParticipanti, esteNumarParticipantiValid } from './CampParticipanti';

interface ParticipantsSlideProps {
    value: number | null;
    onChange: (value: number | null) => void;
    onSubmit: () => void;
    isSubmitting?: boolean;
}

export function ParticipantsSlide({
    value,
    onChange,
    onSubmit,
    isSubmitting = false,
}: ParticipantsSlideProps) {
    const [incercat, setIncercat] = useState(false);

    const handleSubmitClick = () => {
        if (!esteNumarParticipantiValid(value)) {
            setIncercat(true);
            return;
        }
        onSubmit();
    };

    return (
        <div className="ecotic-form-card space-y-6">
            <div className="space-y-2">
                <h2 className="text-2xl font-bold text-foreground">
                    Mai e un pas: numărul de participanți
                </h2>
                <p className="text-muted-foreground">
                    Fotografiile au fost trimise. Confirmă câți elevi au participat, ca răspunsul să fie complet.
                </p>
            </div>

            <CampParticipanti
                value={value}
                onChange={onChange}
                disabled={isSubmitting}
                incercatTrimiterea={incercat}
            />

            <div className="flex justify-center pt-2">
                <Button
                    onClick={handleSubmitClick}
                    disabled={isSubmitting}
                    size="lg"
                    className="min-w-[200px]"
                >
                    {isSubmitting ? 'Se salvează...' : 'Salvează numărul'}
                </Button>
            </div>
        </div>
    );
}
